// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 2025-09-11 Komarov
import { getContent, getHotelContent } from '../../../Redux/actions';
// ##### 25-05-21 Komarov
import CartDetailsDiv from './CartDetailsDiv';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../server/helpers/uniLog';
// ##### Komarov 2025-07-21
import { decrypt } from '../../../helpers/crypto';
import useValidateQuery from '../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-21
const CartDetails = ({ cartClass }) => {
  // console.log('CART', cart)
  const dispatch = useDispatch();
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  const searchDataEncrypted = localStorage.getItem('search_data');
  let cart;
  if (searchDataEncrypted) {
    cart = decrypt(searchDataEncrypted);
  } else {
    cart = useValidateQuery();
  }

  // ##### 24-09-16 Komarov
  const { user: currentUser } = useSelector(state => state.auth);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/BookingForm/CartDetails.js:getContent(cart.contract_id,locale)'
    );
    // ##### Komarov 2025-07-21
    dispatch(getContent(cart?.contract_id, locale));
    // ##### 23-04-12 Komarov
  }, [cart?.contract_id, locale, dispatch]);

  // ##### 25-02-19 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  const promocode = useSelector(state => state.promocode.promocode);
  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  const deviceType = useSelector(state => state.deviceType);
  const search_data = cart;
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelContent({
        id: search_data?.id, // hotel's id
        city_id: search_data?.city_id,
        language: locale,
        user_id: currentUser.user_id,
        refpartner: company_id,
        sale,
        promocode,
        deviceType,
        company_cipher,
        content_size: 1,
        summary: 1,
      })
    );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.city_id,
    // ##### 25-04-21 Komarov
    search_data?.id, // hotel's id
    sale,
    deviceType,
    company_cipher,
    // ##### 25-05-10 Komarov
    locale,
  ]);

  // ##### Komarov 2025-07-21
  return <CartDetailsDiv cart={cart} className={cartClass} cartClass={cartClass} />;
};

export default CartDetails;
